"use client";
import { useState, useEffect } from "react";

const Popup = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
      {/* z-40 for popup */}
      <div className="bg-white p-16 rounded-md shadow-lg max-w-2xl w-full mx-4 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        {/* Popup Content */}
        <h2 className="text-3xl font-bold mb-4 text-center">Go Solar Today!</h2>
        <p className="text-lg mb-6 text-center">
          Switch to solar energy and save up to 100% on your electricity bills. Contact us now!
        </p>

        {/* Contact Us Button */}
        <div className="flex justify-center">
          <button
            onClick={() => {
              window.location.href = "/#contact"; // Navigate to the contact section
              onClose(); // Close the popup
            }}
            className="bg-[#40204A] text-white px-6 py-3 rounded-lg hover:scale-105 text-lg"
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export const usePopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000); // Show popup after 10 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return { showPopup, handleClosePopup };
};

export default Popup;